import { SortBy } from '../../hooks/useBaseTableFilters/types';
import { TypenameExtended } from './customTypes';
import { AdAccountSortBy, AdAccountSortOptions, OrderOption } from './types';

export const getObjectWithoutTypeName = <T extends TypenameExtended>(obj: T): Omit<T, '__typename'> => {
  return {
    ...obj,
    __typename: undefined,
  };
};

export function convertSortByArrayToSortOptions(x: SortBy<AdAccountSortBy>[]): AdAccountSortOptions {
  if (x === undefined || x[0] === undefined) {
    return {
      sortBy: AdAccountSortBy.Name,
      sortOrder: OrderOption.Asc,
    };
  } else {
    // Default to name if id doesn't exist
    let valSortBy: AdAccountSortBy = AdAccountSortBy.Name;
    if (x[0].id !== undefined) {
      valSortBy = x[0].id;
    }

    // Default to Ascending if desc flag isn't specified
    let valOrder: OrderOption = OrderOption.Asc;
    if (x[0].desc !== undefined) {
      valOrder = x[0].desc ? OrderOption.Desc : OrderOption.Asc;
    }

    return {
      sortBy: valSortBy,
      sortOrder: valOrder,
    };
  }
}
